import {
  AccessTime,
  ArrowDownward,
  Delete,
  KeyboardDoubleArrowDown,
  KeyboardDoubleArrowDownOutlined,
  KeyboardDoubleArrowUpOutlined,
  Masks,
  Today,
} from '@mui/icons-material';
import { IconButton, Stack } from '@mui/material';
import RadioLikeSelectCard from 'Global/Components/CommonComponents/RadioLikeSelectCard/RadioLikeSelectCard';
import React from 'react';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import TurnDetails from './TurnDetails';
import { useState } from 'react';
import { DeleteMyTurn } from '../Adapters/DeleteMyTurn';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';

const TurnOverview = ({
  turn,
  setForceRender,
  loading,
  setLoading,
  screenWidth,
}) => {
  const [showDetails, setShowDetails] = useState(false);
  const [loadingEnabler, setloadingEnabler] =
    useState(false);
  const cancelAppointmentMsg = FindLangKey(
    'turn-list-alert-make-sure-cancel'
  );
  const HandleDeleteTurn = () => {
    SwalAlert('warning', cancelAppointmentMsg, true, () => {
      DeleteMyTurn(
        turn?.IdNobat,
        setForceRender,
        setLoading,
        setloadingEnabler
      );
    });
  };

  return (
    <React.Fragment>
      <RadioLikeSelectCard
        disableAction={loading}
        replaceLoading={loading && loadingEnabler}
        // onClickCard={(event) => {
        //   if (
        //     event.target.tagName === 'DIV' ||
        //     event.target.tagName === 'P'
        //   ) {
        //     setShowDetails((prev) => !prev);
        //   } else {
        //     setloadingEnabler(false);
        //   }
        // }}
        isFrameCard={true}
        isAction={true}
        ActionIcon={
          <Delete
            sx={{
              fill: themeColors.ColorPrimary,
            }}
          />
        }
        ActionColor="error"
        ActionFn={HandleDeleteTurn}
        customtitle={
          <Stack
            gap="1em"
            pt=".5em"
            sx={{
              color: `${themeColors.ColorPrimary} !important`,
              width: '100%',
            }}
          >
            <Stack direction="row-reverse" gap="1em">
              <Today
                sx={{
                  fill: `${themeColors.ColorPrimary} !important`,
                }}
              />
              <p>{ArabicToPersian(turn?.Dayname)}</p>
            </Stack>
            <Stack direction="row-reverse" gap="1em">
              <AccessTime
                sx={{
                  fill: `${themeColors.ColorPrimary} !important`,
                }}
              />
              <p>{turn?.DateAndTime}</p>
            </Stack>
            <Stack direction="row-reverse" gap="1em">
              <Masks
                sx={{
                  fill: `${themeColors.ColorPrimary} !important`,
                }}
              />

              {turn?.DoctorName ? (
                <p>{ArabicToPersian(turn?.DoctorName)}</p>
              ) : (
                <p>
                  {ArabicToPersian(turn?.HospitallName)} - 
                  {ArabicToPersian(
                    turn?.ServiceNameBarname
                  )}
                </p>
              )}
            </Stack>

            <Stack
              sx={{
                width: '100%',
              }}
            >
              {!showDetails ? (
                <IconButton
                  sx={{
                    marginTop: '1em',
                    alignSelf: 'center',
                  }}
                  onClick={() => {
                    setShowDetails((prev) => !prev);
                    setloadingEnabler(false);
                  }}
                >
                  <KeyboardDoubleArrowDownOutlined color="colorPrimer" />
                </IconButton>
              ) : (
                <></>
              )}
            </Stack>

            <TurnDetails
              turn={turn}
              showDetails={showDetails}
            />
            {showDetails ? (
              <IconButton
                sx={{
                  marginTop: '1em',
                  alignSelf: 'center',
                }}
                onClick={() => {
                  setShowDetails((prev) => !prev);
                  setloadingEnabler(false);
                }}
              >
                <KeyboardDoubleArrowUpOutlined color="colorPrimer" />
              </IconButton>
            ) : (
              <></>
            )}
          </Stack>
        }
      />
    </React.Fragment>
  );
};

export default TurnOverview;
